/** @format */


export default class Tabs {
	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Tabs();

		self.attachEvents();
	}

	static openTabById(id) {
		const self = new Tabs(),
			$link = $('a.js-tab-link[href="' + id + '"]');

		self.openTab($link);
	}

	attachEvents() {
		const self = this;

		$(document).on("click", ".js-tab-link", function (e) {
			const allowDefault = $(this).data("allow-default");

			// Needed for locker room kitbuilder tab in account area
			if (!allowDefault) {
				e.preventDefault();
			} else {
				$("html").css("scroll-behavior", "smooth");
				$("body").css("scroll-behavior", "smooth");
			}

			self.openTab($(this));
		});


		$(document).on("click", ".download-all-images", function () {
			console.log("download all images");

			downloadAllImagesAsZip();

		});

		$(document).on("click", ".js-show-returned-items", function (e) {
			e.preventDefault();
			ShowReturnedItems();
		});
		$(document).on("click", ".js-show-return-items", function (e) {
			e.preventDefault();
			ShowReturnItems();
		});
	}

	openTab($link) {
		const self = this;

		let tabId = $link.attr("href"),
			$tab = $(tabId),
			$wrapper = $tab.parents(".tabs");

		if ($wrapper.length > 0) {
			$link = $wrapper.find('[href="' + tabId + '"]');
		} else {
			$wrapper = $link.parents(".tabs");
			$link = $wrapper.find('[href="' + tabId + '"]');
		}

		self.closeTabs($link);

		$link.parent("li").addClass("is-active");

		$tab.addClass("is-active");

		$tab.find(".js-carousel").each(function () {
			if ($(this).hasClass("slick-initialized")) {
				$(this).slick("setPosition");
			}
		});

		$(document).trigger("tabChange");
	}

	closeTabs($link) {
		const self = this;

		var $wrapper = $link.parents(".tabs"),
			$tabs = $wrapper.find(".tabs-pane"),
			$links = $wrapper.find(".tabs-nav li");

		$links.removeClass("is-active");
		$tabs.removeClass("is-active");
	}

	ShowReturnItems(){
		$(".return-items").removeClass("d-none");
		$(".returned-items").addClass("d-none");
}
	ShowReturnedItems(){
		$(".return-items").addClass("d-none");
		$(".returned-items").removeClass("d-none")
	}
}

function downloadAllImagesAsZip() {
    var zip = new JSZip();
    var images = document.querySelectorAll('.product-img');
    var zipFilename = "productimages.zip";

    if (images.length === 0) {

        return;
    }

    // Use a Set to avoid duplicate URLs
    var seen = new Set();
    var fetchPromises = Array.from(images).map(function(img, idx) {
        var url = img.src;
        if (seen.has(url)) return Promise.resolve(); // skip duplicates
        seen.add(url);

        // Always use a unique filename
		var num = Math.floor(Math.random() * 90000) + 10000;
        var ext = url.split('.').pop().split('?')[0];
        var filename = `image${idx + num}.${ext}`;

        return fetch(url)
            .then(res => {
                if (!res.ok) throw new Error('Network response was not ok');
                return res.blob();
            })
            .then(blob => {
                zip.file(filename, blob);
            })
            .catch((err) => {
                console.warn(`Failed to fetch image: ${url}`, err);
            });
    });

    Promise.all(fetchPromises).then(function() {
        zip.generateAsync({type:"blob"}).then(function(content) {
            saveAs(content, zipFilename);
        });
    });
}
